module.exports = __webpack_public_path__ + "static/media/kjsieit-navbar.51657a9c.png";